import { Check, XClose } from "@liftedcare/solidjs-untitled-icons/duocolor";
import { JSXElement, Match, ParentComponent, Show, Switch } from "solid-js";

import { Pill } from "./Pill";

export const BooleanValueDisplay: ParentComponent<{
  value?: boolean | null;
  name?: string;
  type?: "icon" | "yes-no" | "pill";
  iconClasses?: string;
  fallback?: string | JSXElement;
}> = (props) => {
  const classes = () => {
    return `${props.iconClasses} size-5`;
  };

  const falseDisplayValue = () => {
    const type = props.type ?? "icon";
    if (type === "icon") {
      return <XClose class={`${classes()} text-error-500`} />;
    } else if (type === "yes-no") {
      return "No";
    } else {
      return <Pill type="error">No</Pill>;
    }
  };
  const trueDisplayValue = () => {
    const type = props.type ?? "icon";
    if (type === "icon") {
      return <Check class={`${classes()} text-green-500`} />;
    } else if (type === "yes-no") {
      return "Yes";
    } else {
      return <Pill type="success">Yes</Pill>;
    }
  };

  return (
    <div class="flex items-center gap-1">
      <Switch fallback={props.fallback ?? falseDisplayValue()}>
        <Match when={props.value === false}>{falseDisplayValue()}</Match>
        <Match when={props.value === true}>{trueDisplayValue()}</Match>
      </Switch>
      <Show when={props.name}>{props.name}</Show>
      <Show when={props.children}>{props.children}</Show>
    </div>
  );
};
